import { tss } from 'tss-react';
import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return tss.create(() => {
    return {
      section: {
        marginBottom: theme.spacing(4)
      },
      setting: {
        maxWidth: 800,
        minWidth: 400
      },
      input: {
        display: 'inline-block',
        marginBottom: theme.spacing(1)
      }
    };
  })();
};
